import React, { useEffect, useState} from 'react';
import { Button} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import * as RestService from '../../services/eisRest';
import CustomSelect from '../../components/custom-select/CustomSelect';
import DatePicker, { registerLocale } from "react-datepicker";
import sk from 'date-fns/locale/sk';

import ChangePasswordModal from './ChangePasswordModal';
import FittedImage from 'react-fitted-image';
import "react-datepicker/dist/react-datepicker.css";
registerLocale('sk', sk)




const PersonalAndAccountTab = (props) => {

 //   const [selectedRecord, setSelectedRecord] =  useState(null);  
    const [t] = useTranslation();         
//    const [data, setData] = useState();

    const [showChangePassworModal, setShowChangePassworModal] = useState();
    const [user, setUser] = useState();
    const [workPositionList, setWorkPositionList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [userStatusList, setUserStatusList] = useState([]);    
  //  const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [initialData,setInitialData] = useState(null);
    const [employedSince, setEmployedSince] = useState(new Date().getTime());
    const [disabledAccount, setDisabledAccount] = useState();
    const [userStatusId, setUserStatusId] = useState();
    const [departmentId, setDepartmentId] = useState();
    const [workPositionId, setWorkPositionId] = useState();
    const [userImage, setUserImage] = useState();

   // const disabledAccountRef = useRef();

    const yesNoOptions = [
      { value: 1, label:  t('general.label.yes')},
      { value: 0, label:  t('general.label.no')}                  
    ];
      
  
    
    const hideModal = () => {
      props.parentCallback();
    };
    
  

 
    

    const getUserImage = (selectedRecord) => {  
      RestService.callAnyApi('file/getFileByEntityId?entityId='+selectedRecord, '[]')
      .then((data) => {                                     
              try{
                setUserImage(data.fileBody);                
              }catch(error){
                  console.error();
              }
             
      })
      .catch((error) => {               
          toast.error(
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                  'Failed'
          );
      });
    
    
    }

    const uploadUserImage = (event) =>{

      RestService.uploadFile(event.target.files[0],null,props.selectedRecord,props.selectedRecord,"userImage","1")
        .then((response) => {         
          getUserImage(props.selectedRecord);
        })        
        .catch((error) => {
          toast.error(error);
        });    
    }
   

    useEffect(() => {      
    //  setSelectedRecord(props.selectedRecord);
    RestService.callAnyApi('user/getUser?id='+props.selectedRecord, null)
    .then((data) => {
         setUser(data);               
         //setDisabledAccount(data.disabledAccount);
         setDisabledAccount(data.disabledAccount);
         setUserStatusId(data.userStatusId.toString());
         setDepartmentId(data.departmentId);
         setWorkPositionId(data.workPositionId);
         setEmployedSince(data.employedSince);
       //  setInitialData(dataTemp);
         
        // disabledAccountRef.current.select.setValue(data.disabledAccount);
                    
    })
    .catch((error) => {    
      toast.error(error);
    });
      getUserImage(props.selectedRecord);
    

    }, [props.selectedRecord]) //, getUserImage

    useEffect(() => {      
          RestService.callAnyApi('user/getWorkPositions', null).then((data) => { setWorkPositionList(data);  }).catch((error) => {});
          RestService.callAnyApi('company/getDepartmentSelectList', null).then((data) => { setDepartmentList(data);   }).catch((error) => {});
          RestService.callAnyApi('user/getUserStatusOptions', null).then((data) => { 
            for (var i = 0; i < data.length; i++) {
                //var object = data[i];            
                data[i]['label'] = t('user.label.'+(data[i]['label']));
                data[i]['value'] = Number(data[i]['value']);
            }
            setUserStatusList(data);          
          }).catch((error) => {});
    }, [])

  
  


    
    const callbackChangePasswordModal = () =>{
      setShowChangePassworModal(false);
    }
    
    const changePassword = () =>{
      setShowChangePassworModal(true);
    }
   
    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
       
      try{

        if(employedSince==0){
          setEmployedSince(null);
        }
        user.login = values.login;        
        user.address.firstName = values.firstName;        
        user.address.lastName = values.lastName;        
        user.employedSince = employedSince;
        user.personalNumber = values.personalNumber;
        user.address.street = values.street;
        user.address.houseNumber = values.houseNumber;
        user.address.city = values.city;
        user.address.postalCode = values.postalCode;
        user.address.phone = values.phone;
        user.address.mobilePhone = values.mobilePhone;
        user.address.officeEmail = values.officeEmail;
        user.address.privateEmail = values.privateEmail;
        user.address.description = values.description;        
        
        user.disabledAccount = disabledAccount;
        user.userStatusId = userStatusId;  
        user.departmentId = departmentId;      
        user.workPositionId = workPositionId;

      }catch(error){
        console.log(error);
      }

      RestService.callAnyApi(url,user)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                                                      
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {

        login: user ? user.login : '',                       
        firstName: user ? user.address.firstName : '',
        lastName:  user ?  user.address.lastName : '',                                    
        employedSince:  user ? user.employedSince : '',
        personalNumber: user ?  user.personalNumber : '',
        street:  user ?  user.address.street : '',
        houseNumber: user ?  user.address.houseNumber : '',
        city:  user ? user.address.city : '',
        postalCode:  user ? user.address.postalCode : '',
        phone: user ?  user.address.phone : '',
        mobilePhone:  user ? user.address.mobilePhone : '',
        officeEmail:  user ? user.address.officeEmail : '',
        privateEmail:  user ?  user.address.privateEmail : '',
        description: user ?  user.address.description : '',     

        disabledAccount: user ? user.disabledAccount : '',
        userStatusId: user ? user.userStatusId : '',  
        departmentId: user ? user.departmentId : '',      
        workPositionId: user ? user.workPositionId : '',

      }
      
      
      ,
      validationSchema: Yup.object({
         firstName: Yup.string()   
          .nullable()  
          .required(t('general.message.required')),
        lastName: Yup.string()     
          .nullable()  
          .required(t('general.message.required')),
        officeEmail: Yup.string()
          .nullable()  
          .email(),
        personalEmail: Yup.string()
          .nullable()  
          .email(),
      }),
      onSubmit: (values) => {           
          save('user/savePersonal',values);         
      }
      
    });



    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
                      <form onSubmit={formik.handleSubmit}>     
                      <div className="row">
    							          <div className="col-9 col-sm-9 col-lg-9">
    								            <div className="row">

    									              <div className="col-6 col-sm-6 col-lg-6">
                  								      <div className="form-group">
                    								      <label>{t('user.label.login')}</label>
                    								      <input type="text" className="form-control" {...formik.getFieldProps('login')}  placeholder={t('user.label.login')} />                                            
                    							      </div>
                                        {formik.touched.login && formik.errors.login ? (<div style={{ color: 'red' }}>{formik.errors.login}</div>) : null} 
                    					      </div>			                    					

                                    <div className="col-3 col-sm-3 col-lg-3">
                    							        <div className="form-group">                    								
                                              <Button className="btn-default" onClick={changePassword} style={{"marginTop":"32px"}}><i className="fa fa-key" aria-hidden="true"></i></Button>
                                          </div>
                  								  </div>

                                    <div className="col-3 col-sm-3 col-lg-3">
                  					      	  <div className="form-group">
                        					      <label>{t('user.label.disabledAccount')}</label>
                                        <CustomSelect                                          
                                            className='input'
                                            name="disabledAccount"                                         
                                            onChange={(opt, e) => {                                                                                          
                                              formik.setFieldValue('disabledAccount', opt.value);
                                              setDisabledAccount(opt.value);
                                            }}
                                            value={formik.values.disabledAccount} 
                                            options={yesNoOptions}     
                                        />           
                   						        </div>
                                      {formik.touched.disabledAccount && formik.errors.disabledAccount ? (<div style={{ color: 'red' }}>{formik.errors.disabledAccount}</div>) : null} 
                   				        	</div>  

                                </div>                               
                                <div className="row">

    	               					      <div className="col-4 col-sm-4 col-lg-4">
        	          						          <div className="form-group">
        	          		 					            <label>{t('user.label.firstName')}</label>
            	            				  	        <input type="text" className="form-control"  {...formik.getFieldProps('firstName')}  placeholder={t('user.label.firstName')} />
	            	       					          </div>
                                          {formik.touched.firstName && formik.errors.firstName ? (<div style={{ color: 'red' }}>{formik.errors.firstName}</div>) : null}
                   						      </div>

                   		    		      <div className="col-5  col-sm-5 col-lg-5">
        	          					  	        <div className="form-group">
        	          		 				    	        <label>{t('user.label.lastName')}</label>
            	            					          <input type="text" className="form-control"  {...formik.getFieldProps('lastName')} placeholder={t('user.label.lastName')} />
	            	       					          </div>
                                          {formik.touched.lastName && formik.errors.lastName ? (<div style={{ color: 'red' }}>{formik.errors.lastName}</div>) : null}
                   						      </div>  

                   						      <div className="col-3 col-sm-3 col-lg-3">
                                          <div className="form-group">
                                              <label>{t('user.label.userStatus')}</label>                               
                                              <CustomSelect
                                                  className='input'
                                                  name="userStatusId"                                         
                                                  onChange={(opt, e) => {                                                                                                   
                                                      formik.setFieldValue('userStatusId', opt.value);
                                                      setUserStatusId(Number(opt.value));
                                                  }}
                                                  value={formik.values.userStatusId}
                                                  options={userStatusList}     
                                              />                                
                                          </div>  
                                          {formik.touched.userStatusId && formik.errors.userStatusId ? (<div style={{ color: 'red' }}>{formik.errors.userStatusId}</div>) : null}                  
                   						      </div>      
                                 
                      					</div>  


                               

                               
                          
                            </div>  

                            <div className="col-3 col-sm-3 col-lg-3" >
                  		   			    <div className="shadow  bg-white rounded justify-content-center" style={{"marginTop": "25px"}}> {/*p-3 mb-3*/}
                  					          <div className="form-group d-flex justify-content-center" >
                  					              <label >      										                 
                                              <input type="file" accept="image/png" onChange={uploadUserImage} style={{"display": "none"}} />
      										                    <FittedImage border="1"  style={{'maxHeight': '130px'}}  fit="contain" src={userImage ? `data:image/png;base64,${userImage}` :  require('../../img/no_image.png')} alt=""/>
   									                      </label>
   									                  </div>
   									              </div>
                              </div>

                      </div>
                     

                                       
                      <div className="row">                 					

                              <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                    <label>{t('user.label.employedSince')}</label>                                                                               
                                        <DatePicker
                                            className='form-control'
                                          //  selected={initialData.employedSince}
                                          // onSelect={value=>formik.setFieldValue('employedSinceInput',value.value)}
                                          //  onChange={value=>formik.setFieldValue('employedSinceInput',value.value)}
                                            selected={employedSince}
                                            onChange={(value) => setEmployedSince(new Date(value).getTime())}                                            
                                            dateFormat="dd.MM.yyyy"
                                          // locale="sk"                                                  
                                        />                                                   						
                                </div>
                              </div>        
                              <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                      <label>{t('user.label.workPosition')}</label>
                                      <CustomSelect
                                      className='input'
                                      name="workPositionId"
                                      onChange={(opt, e) => {                                             
                                        setWorkPositionId(opt.value);
                                        formik.setFieldValue('workPositionId', opt.value);
                                      }}
                                      value={formik.values.workPositionId}
                                      options={workPositionList}     
                                  />                                
                                </div>  
                                {formik.touched.workPositionId && formik.errors.workPositionId ? (<div style={{ color: 'red' }}>{formik.errors.workPositionId}</div>) : null}     
                              </div>


                              <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                  <label>{t('user.label.department')}</label>                               
                                  <CustomSelect
                                      className='input'
                                      name="departmentId"
                                      onChange={(opt, e) => {                                             
                                        setDepartmentId(opt.value);
                                        formik.setFieldValue('departmentId', opt.value);
                                      }}
                                      value={formik.values.departmentId}
                                      options={departmentList}     
                                  />                                
                                </div>  
                                {formik.touched.departmentId && formik.errors.departmentId ? (<div style={{ color: 'red' }}>{formik.errors.departmentId}</div>) : null}                            
                              </div>    



                              <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                    <label style={{"marginRight": "5px"}}>{t('user.label.personalNumber')}</label>                    					
                                    <input type="text" className="form-control col-4 col-sm-4 col-lg-4" {...formik.getFieldProps('personalNumber')} placeholder="" />                    					
                                </div>
                              </div> 



                    </div>                              
                

                    <div className="row">
    	               				<div className="col-3  col-sm-3 col-lg-3">
        	          				    <div className="form-group">
        	          		 			      <label>{t('user.label.street')}</label>
            	            			    <input type="text" className="form-control" value="" {...formik.getFieldProps('street')}  placeholder={t('user.label.street')} />
	            	       			    </div>
                                 {formik.touched.street && formik.errors.street ? (<div style={{ color: 'red' }}>{formik.errors.street}</div>) : null}
                   					</div>
                   		  		<div className="col-3 col-sm-3 col-lg-3">
        	          				    <div className="form-group">
        	          		 			      <label>{t('user.label.houseNumber')}</label>        	          		 			
            	            		    	<input type="text" className="form-control" {...formik.getFieldProps('houseNumber')}  placeholder={t('user.label.houseNumber')} />            	            		
                                </div>
                                {formik.touched.houseNumber && formik.errors.houseNumber ? (<div style={{ color: 'red' }}>{formik.errors.houseNumber}</div>) : null}
	            	       			</div>	            	       			
	            	       			<div className="col-3  col-sm-3 col-lg-3">
        	          				      <div className="form-group">
        	          		 			        <label>{t('user.label.city')}</label>
            	            		      	<input type="text" className="form-control" {...formik.getFieldProps('city')}  placeholder={t('user.label.city')} />
	            	       			      </div>
                                   {formik.touched.city && formik.errors.city ? (<div style={{ color: 'red' }}>{formik.errors.city}</div>) : null}
                   					</div>
                   		  		<div className="col-3 col-sm-3 col-lg-3">
        	          				      <div className="form-group">
        	          		 			        <label>{t('user.label.postalCode')}</label>        	          		 			
            	            			      <input type="text" className="form-control" {...formik.getFieldProps('postalCode')} placeholder={t('user.label.postalCode')} />            	            		
	            	       			      </div>
                                   {formik.touched.postalCode && formik.errors.postalCode ? (<div style={{ color: 'red' }}>{formik.errors.postalCode}</div>) : null}
	            	       			</div>
                   				
                  	</div>     


                    <div className="row">
    	               				<div className="col-3  col-sm-3 col-lg-3">
        	          				    <div className="form-group">
        	          		 			      <label>{t('user.label.phone')}</label>
            	            		    	<input type="text" className="form-control" {...formik.getFieldProps('phone')}  placeholder={t('user.label.phone')} />
	            	       		      </div>
                                 {formik.touched.phone && formik.errors.phone ? (<div style={{ color: 'red' }}>{formik.errors.phone}</div>) : null}
                   					</div>
                   		  		<div className="col-3 col-sm-3 col-lg-3">
        	          				    <div className="form-group">
        	          		 			      <label>{t('user.label.mobilePhone')}</label>        	          		 			
            	            			    <input type="text" className="form-control" {...formik.getFieldProps('mobilePhone')} placeholder={t('user.label.mobilePhone')} />            	            		
	            	       			    </div>
                                 {formik.touched.mobilePhone && formik.errors.mobilePhone ? (<div style={{ color: 'red' }}>{formik.errors.mobilePhone}</div>) : null}
	            	       			</div>
	            	       			<div className="col-3  col-sm-3 col-lg-3">
        	          			      <div className="form-group">
        	          		 			      <label>{t('user.label.officeEmail')}</label>
            	            			    <input type="text" className="form-control" {...formik.getFieldProps('officeEmail')} placeholder={t('user.label.officeEmail')} />
	            	       			    </div>
                                 {formik.touched.officeEmail && formik.errors.officeEmail ? (<div style={{ color: 'red' }}>{formik.errors.officeEmail}</div>) : null}
                   					</div>
                   		  		<div className="col-3 col-sm-3 col-lg-3">
        	          				      <div className="form-group">
        	          		 			        <label>{t('user.label.privateEmail')}</label>        	          		 			
            	            			      <input type="text" className="form-control" {...formik.getFieldProps('privateEmail')}  placeholder={t('user.label.privateEmail')} />            	            		
	            	       			      </div>
                                   {formik.touched.privateEmail && formik.errors.privateEmail ? (<div style={{ color: 'red' }}>{formik.errors.privateEmail}</div>) : null}
	            	       			</div>
                   				
                  		 	</div>  	


                        <div className="row">
    	               				<div className="col-12 col-sm-12 col-lg-12">
        	          				    <div className="form-group">
        	          		 			      <label>{t('user.label.description')}</label>        	          		 			
            	            			    <input type="text" className="form-control" {...formik.getFieldProps('description')} placeholder={t('user.label.description')} />            	            		
	            	       			    </div>
                                 {formik.touched.description && formik.errors.description ? (<div style={{ color: 'red' }}>{formik.errors.description}</div>) : null}
	            	       			</div>
                  			</div>
                      

                        <div className="card-footer">
                            <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>     
                            <Button className="btn-default float-right" onClick={hideModal}>{t('general.button.cancel')}</Button>    
                                                    
	            	       			
                  			</div>
                        </form>

                        
          <ChangePasswordModal 
            modal={showChangePassworModal}   
            parentCallback={callbackChangePasswordModal}
            userId={user ? user.id : ''}                    
          />

        </div>
    );
};

export default PersonalAndAccountTab;